import React, { useState } from 'react';
import { CustomerPrivacySecurityContext } from '../CustomerPrivacySecurityContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const CustomerPrivacySecurityContextProvider = _ref => {
  let {
    children
  } = _ref;
  const [areAllSectionsExpanded, setAreAllSectionsExpanded] = useState(false);
  return /*#__PURE__*/_jsx(CustomerPrivacySecurityContext.Provider, {
    value: {
      areAllSectionsExpanded,
      setAreAllSectionsExpanded
    },
    children: children
  });
};